module.exports = __webpack_public_path__ + "static/img/2.af5fbb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/benjyfishy/2.png
// module id = z0S2
// module chunks = 35